export function returnCorrectProduct(pricesData, TemptedPriceOfAnchor) {
  const result = {};
  const { data } = pricesData;
  const { products } = data;
  const someProductsHaveFee = products?.filter((p) => p?.details?.fee > 0)?.length > 1;
  const someProductsHaveRecurringAmount = products?.filter((p) => p.details?.recurringAmount > 0)?.length > 1;

  if (someProductsHaveFee) {
    result.priceInfo = products.filter((p) => String(p.details.recurringAmount) === String(TemptedPriceOfAnchor));
    result.fee = true;

    if (result.priceInfo.length === 0) {
      return returnDynamicPackageResult(result, products, TemptedPriceOfAnchor);
    }

    return result;
  } else if (someProductsHaveRecurringAmount) {
    result.priceInfo = products.filter((p) => String(p.details.recurringAmount) === String(TemptedPriceOfAnchor));
    result.fee = false;

    if (result.priceInfo.length === 0) {
      return returnDynamicPackageResult(result, products, TemptedPriceOfAnchor);
    }

    return result;
  }

  result.priceInfo = products.filter((p) => String(p.amount) === String(TemptedPriceOfAnchor));
  result.fee = false;

  if (result.priceInfo.length === 0) {
    return returnDynamicPackageResult(result, products, TemptedPriceOfAnchor);
  }

  return result;
}

function getPrice(product, price) {
  if (parseInt(product?.recurringAmount, 10) === parseInt(price, 10)) {
    return parseInt(product.recurringAmount, 10) === parseInt(price, 10);
  }

  if ((parseInt(product.amount, 10) - parseInt(product?.details?.fee, 10)) === parseInt(price, 10)) {
    return (parseInt(product.amount, 10) - parseInt(product?.details?.fee, 10)) === parseInt(price, 10);
  }

  return parseInt(product.amount, 10) === parseInt(price, 10);
}

function returnDynamicPackageResult(result, products, amount) {
  let dynamicPackage = products[0];
  dynamicPackage.details.recurringAmount = amount;
  dynamicPackage.amount = amount + (dynamicPackage?.details?.fee || 0);
  dynamicPackage.details.isDynamicPrice = true;
  result.priceInfo = [dynamicPackage];
  result.fee = dynamicPackage.details.fee > 0;

  return result;
}

export function findMatchingProduct(pricesData, priceToMatch) {
  const result = pricesData.find((product) => getPrice(product, priceToMatch));

  return result;
}

function findFirstLowerPriceProductIndex(products, TemptedPriceOfAnchor, checkAmount) {
  let lowestDifference = Infinity;
  let indexOfProduct = null;
  const maxAcceptedDifference = 5;
  products.forEach((product, index) => {
    const price = !checkAmount ? parseInt(product.details.recurringAmount, 10) : parseInt(product.amount, 10);
    const temptedPrice = parseInt(TemptedPriceOfAnchor, 10);
    const currentDiff = temptedPrice - price;
    const differenceIsBetweenBounds = (currentDiff <= maxAcceptedDifference) && (currentDiff > 0);
    const differenceIsLower = currentDiff < lowestDifference;

    if (differenceIsLower && differenceIsBetweenBounds && index !== 0) {
      indexOfProduct = index;
      lowestDifference = currentDiff;
    }
  });

  return indexOfProduct;
}

export function returnFirstLowerProduct(pricesData, TemptedPriceOfAnchor) {
  const result = {};
  const { data } = pricesData;
  const { products } = data;

  const someProductsHaveFee = products?.filter((p) => p?.details?.fee > 0)?.length > 1;

  const index = findFirstLowerPriceProductIndex(products, TemptedPriceOfAnchor, true);
  result.fee = someProductsHaveFee;
  result.priceInfo = [products[index]];

  return result;
}


